import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesAnnualCosts from '../../Utilities/UtilitiesEstimatedAnnualCost/UtilitiesAnnualCosts';
import { NATURAL_GAS } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function NaturalGasAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={NATURAL_GAS.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Natural gas"
      knowAnnualCostsUtilityProviderField={NATURAL_GAS.FIELD_NAME.KNOW_ANNUAL_COSTS_UTILITY_PROVIDER}
    />
  );
}

export default NaturalGasAnnualCosts;
